import { GtmConfig } from '@seven1/angular/gtm';
import { UsercentricsConfig } from '@seven1/angular/usercentrics';
import { KameleoonConfig } from '@seven1/angular/kameleoon';
import { InsuranceUrlConfig } from './environment.interface';
import { SB_RICH_TEXT_OPTIONS, StoryblokConfig } from '@seven1/angular-storyblok/api';
import { APP_COMPONENTS } from './components';

export const CMS_CONFIG_STAGE: StoryblokConfig = {
    accessToken: '9RwWhKb3s5D67eniqMOjeQtt',
    storyBasePath: 'saferyou',
    layoutStorySlug: '/layout',
    redirectsStorySlug: '/redirects',
    blogSlug: 'ratgeber',
    blogArticleContentTypeKey: 'sy_BlogArticlePage',
    version: 'draft',
    components: APP_COMPONENTS,
    cache: {
        clear: 'auto',
        type: 'memory',
    },
    richText: SB_RICH_TEXT_OPTIONS,
};

export const CMS_CONFIG_LIVE: StoryblokConfig = {
    accessToken: 'Lht2BVpWBLtcvhIrQucbtgtt',
    storyBasePath: 'saferyou',
    layoutStorySlug: '/layout',
    redirectsStorySlug: '/redirects',
    blogSlug: 'ratgeber',
    blogArticleContentTypeKey: 'sy_BlogArticlePage',
    version: 'published',
    components: APP_COMPONENTS,
    cache: {
        clear: 'auto',
        type: 'memory',
    },
    richText: SB_RICH_TEXT_OPTIONS,
};

export const TARIFF_ENV = {
    routes: ['/single/basis', '/single/comfort', '/single/premium', '/family/basis', '/family/comfort', '/family/premium'],
};

export const GTM_ENV: GtmConfig = {
    url: 'https://www.googletagmanager.com/',
    id: 'GTM-TVT7964W',
};

export const UC_ENV: UsercentricsConfig = {
    id: 'jA_l2tB3EY4z7s',
    url: 'https://s.p7s1.io/cmp/cmp-saferyou-web.js',
    targetUrl: 'https://versichern.saferyou.de',
    excludedRoutes: ['/impressum', '/datenschutz'],
};

export const KAMELEOON_ENV: KameleoonConfig = {
    siteCode: '588qtxgifj',
};


export const INSURANCE_ENV_TEST: {
    none: string;
    single: InsuranceUrlConfig;
    family: InsuranceUrlConfig;
} = {
    none: 'https://test-versichern.saferyou.de/exttr/index.html',
    single: {
        basic: 'https://test-versichern.saferyou.de/exttr/saferyou?leistungsvariante=Basis&tarifgruppe=Single',
        comfort: 'https://test-versichern.saferyou.de/exttr/saferyou?leistungsvariante=Komfort&tarifgruppe=Single',
        premium: 'https://test-versichern.saferyou.de/exttr/saferyou?leistungsvariante=Premium&tarifgruppe=Single',
    },
    family: {
        basic: 'https://test-versichern.saferyou.de/exttr/saferyou?leistungsvariante=Basis&tarifgruppe=Familie',
        comfort: 'https://test-versichern.saferyou.de/exttr/saferyou?leistungsvariante=Komfort&tarifgruppe=Familie',
        premium: 'https://test-versichern.saferyou.de/exttr/saferyou?leistungsvariante=Premium&tarifgruppe=Familie',
    },
};

export const INSURANCE_ENV: {
    none: string;
    single: InsuranceUrlConfig;
    family: InsuranceUrlConfig;
} = {
    none: 'https://versichern.saferyou.de/exttr/index.html',
    single: {
        basic: 'https://versichern.saferyou.de/exttr/saferyou?leistungsvariante=Basis&tarifgruppe=Single',
        comfort: 'https://versichern.saferyou.de/exttr/saferyou?leistungsvariante=Komfort&tarifgruppe=Single',
        premium: 'https://versichern.saferyou.de/exttr/saferyou?leistungsvariante=Premium&tarifgruppe=Single',
    },
    family: {
        basic: 'https://versichern.saferyou.de/exttr/saferyou?leistungsvariante=Basis&tarifgruppe=Familie',
        comfort: 'https://versichern.saferyou.de/exttr/saferyou?leistungsvariante=Komfort&tarifgruppe=Familie',
        premium: 'https://versichern.saferyou.de/exttr/saferyou?leistungsvariante=Premium&tarifgruppe=Familie',
    },
};
